<template>
  <SoDialog
    v-model="value"
    card-title="Appointments Offered - Smart Installation"
    data-testid="previous-slots-modal"
  >
    <SoErrorBoundary>
      The appointments below were previously offered to the customer.
      <SoSimpleTable
        :headers="['Appointment', 'Date Offered', 'Channel', 'Installer']"
        :items="tableItems"
        class="mt-6 mb-7 border rounded"
        data-testid="previous-slots-table"
      />
    </SoErrorBoundary>
    <SoButton
      class="d-flex justify-end"
      title="Close"
      large
      data-testid="previous-slots-modal-close-btn"
      @click="value = false"
    />
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import dayjs from "dayjs"
  import { compareDates } from "@/helpers/dateHelper"
  import SoDialog from "@/components/SoDialog.vue"
  import SoSimpleTable from "@/components/SoSimpleTable.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoErrorBoundary from "@/components/SoErrorBoundary.vue"
  import { IImbpSmartMeterOfferedSlot } from "@/models/imbpSmartMeterOfferedSlots/imbpSmartMeterOfferedSlot.types"

  export default defineComponent({
    components: {
      SoDialog,
      SoSimpleTable,
      SoButton,
      SoErrorBoundary,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      slots: {
        type: Array as PropType<IImbpSmartMeterOfferedSlot[]>,
        default: () => [],
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },

      tableItems() {
        return [...this.slots]
          .sort((a, b) =>
            compareDates(dayjs(a.dateOffered), dayjs(b.dateOffered), false),
          )
          .map((item) => [
            item.appointmentSlotFormatted,
            item.dateOfferedFormatted,
            item.channel,
            item.installerLabel,
          ])
      },
    },
  })
</script>
